import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { languageSelector } from 'src/features/language/store';

export const useLang = () => {
  const [isRTL, setIsRTL] = useState<boolean>(false);
  const { lang } = useSelector(languageSelector);
  const rtlLangs = useMemo(() => ['ar'], []);

  useEffect(() => {
    setIsRTL(rtlLangs.includes(lang));
  }, [lang, setIsRTL, rtlLangs]);

  return {
    isRTL,
    lang,
  };
};
